import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_BILLING_STATUS_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: () => null,
  2: (oldDoc) => ({ ...oldDoc, holdReason: null, qaAfterExport: null }),
};
